<template>
  <div class="sidebar hidden-xs-only">
    <div
      v-for="(item, index) in menuList"
      ref="sidebarItem"
      :key="index"
      :class="item.isAct ? 'sidebarItem act' : 'sidebarItem'"
      @click="clickMenu(item)"
      @mouseover="setAct(index)"
      @mouseout="closeAct"
    >
      <i :class="item.icon" class="iconfont" />
      <a v-if="item.id === 13" href="https://rbs.wellsoon.cn" target="_blank">{{ item.cat_name }}</a>
      <span v-else>{{ item.cat_name }}</span>
    </div>
  </div>
</template>

<script>
import API from '@/api/service'

export default {
  data() {
    return {
      id: null,
      menuList: [],
      tempIndex: null
    }
  },
  watch: {
    $route(newVal) {
      this.id = Number(this.$route.params.id)
      if (!this.menuList) {
        this.getMenu()
      }
    },
    tempIndex(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (this.$refs.sidebarItem[oldVal]) {
          this.$refs.sidebarItem[oldVal].classList.add('small')
          const data = setTimeout(() => {
            if (this.$refs.sidebarItem[oldVal]) {
              this.$refs.sidebarItem[oldVal].classList.remove('small')
            }
            clearTimeout(data)
          }, 800)
        }
      }
    }
  },
  mounted() {
    this.id = Number(this.$route.params.id)
    this.getMenu()
  },
  methods: {
    getMenu() {
      API.getArticleCat({ id: this.$route.params.parent_id }).then(res => {
        res.data.map(item => {
          if (Number(item.id) === this.id) {
            item.isAct = true
          } else {
            item.isAct = false
          }
        })
        this.menuList = res.data
      })
    },
    clickMenu(item) {
      if (item.id === 13) {
        // window.open('http://218.17.56.105:8081/', '_blank')
        // window.open('https://rbs.wellsoon.cn', '_blank')
        return false
      }
      this.$router.push({
        name: this.$route.name,
        params: { parent_id: this.$route.params.parent_id, id: item.id }
      })
    },
    setAct(index) {
      this.tempIndex = index
      this.menuList.map((item, oIndex) => {
        if (oIndex === index) {
          item.isAct = true
        } else {
          item.isAct = false
        }
      })
    },
    closeAct() {
      this.menuList.map((item, index) => {
        if (Number(item.id) === this.id) {
          item.isAct = true
        } else {
          item.isAct = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  .sidebarItem {
    display: flex;
    align-items: center;
    font-size: 16px;
    padding: 10px 10px 30px 0;
    text-align: left;
    border-right: none;
    cursor: pointer;
    color: #757272;
    transition: all 0.5;
    &:hover {
      color: #bd9916;
      border-top: none;
      i {
        color: #bd9916;
      }
    }
    &:not(:first-child) {
      border-top: none;
    }
    span {
      transition: all 0.5;
      transform: scale(1);
    }
    i {
      transition: all 0.5;
      transform: scale(1);
      font-size: 30px;
      margin-right: 15px;
    }
    a {
      color: #757272;
      transition: all 0.5;
      transform: scale(1);
    }
  }
  .act {
    span {
      transform: scale(1.3);
      animation: openBig 0.8s;
      animation-timing-function: ease-in-out;
      color: #bd9916 !important;
    }
    a {
      transform: scale(1.3);
      animation: openBig 0.8s;
      animation-timing-function: ease-in-out;
      color: #bd9916 !important;
    }
    i {
      transform: scale(1.3);
      animation: openRightIcon 0.8s;
      animation-timing-function: ease-in-out;
      margin-right: 45px;
      color: #bd9916 !important;
    }

    @keyframes openBig {
      0% {
        transform: scale(1);
        color: #757272;
      }

      100% {
        transform: scale(1.3);
        color: #bd9916 !important;
      }
    }

    @keyframes openRightIcon {
      0% {
        transform: scale(1);
        margin-right: 15px;
        color: #757272 !important;
      }

      100% {
        transform: scale(1.3);
        margin-right: 45px;
        color: #bd9916 !important;
      }
    }
  }
  .small {
    // margin-bottom: 20px;
    span {
      transform: scale(1);
      animation: openSmall 0.8s;
      animation-timing-function: ease-in-out;
      color: #757272 !important;
    }
    a {
      transform: scale(1);
      animation: openSmall 0.8s;
      animation-timing-function: ease-in-out;
      color: #757272 !important;
    }
    i {
      transform: scale(1);
      animation: openRight 0.8s;
      animation-timing-function: ease-in-out;
      margin-right: 15px;
      color: #757272 !important;
    }

    @keyframes openSmall {
      0% {
        transform: scale(1.2);
        color: #bd9916;
      }

      100% {
        transform: scale(1);
        color: #757272 !important;
      }
    }

    @keyframes openRight {
      0% {
        transform: scale(1.2);
        color: #bd9916;
        margin-right: 45px;
      }

      100% {
        transform: scale(1);
        color: #757272 !important;
        margin-right: 15px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sideBar.vue